(function() {
  'use strict';

  angular
    .module('eclipseApp.myAccount')
    .controller('viewInvoiceCtrl', [
      '$scope',
      '$sce',
      '$http',
      'uteEndpoint',
      'uteLocale',
      '$rootScope',
      '$stateParams',
      '$state',
      'viewInvoice',
      'commonService',
      'uteModal',
      'dtmService',
      'dtmServiceConstants',
      'permissionsService',
      '$translate',
      '$injector',
      function(
        $scope,
        $sce,
        $http,
        uteEndpoint,
        uteLocale,
        $rootScope,
        $stateParams,
        $state,
        viewInvoice,
        commonService,
        uteModal,
        dtmService,
        dtmServiceConstants,
        permissionsService,
        $translate,
        $injector
      ) {
        var dynatracePageLoadActionId = null;
        var dynatraceUptoBBLinkActionId = null;
        $scope.epostResponse = false;
        $scope.viewBillSection = true;
        $scope.isSubscriber = false;
        $scope.billingNotification = '';
        commonService.deepLinkState = '';

        var dataLayerPredefinedSection = window.ute.datalayer.common.service.DataLayerPredefinedSection;
        var dataLayerSections = [
          dataLayerPredefinedSection.ACCOUNT,
          dataLayerPredefinedSection.PAGE,
          dataLayerPredefinedSection.SITE
        ];
        var dataLayerService = $injector.get('ute.datalayer.common.service');

        if ($rootScope.userInfo.profileType.subscriber !== null && $rootScope.userInfo.profileType.subscriber !== '') {
          $scope.isSubscriber = $rootScope.userInfo.profileType.subscriber;
          if ($scope.isSubscriber) {
            dataLayerService.track({}, false, dataLayerSections, { mappingKey: 'invoice.viewInvoice' });
          }
        }

        /*if($scope.isSubscriber){
          $state.go('myAccount.payNow');
        }*/
        var selectedAccountDetail;
        var documentId;
        var token;
        $scope.dates = [];
        $scope.epostList = [];
        $scope.bbList = [];
        $scope.bbListUpdated = [];
        var dates = [];
        $scope.tempDates = [];
        var i = 0;
        var latestDate = 0;
        $scope.accountNumber = $stateParams.accountNumber;
        var bbInvoiceLink = '';
        var content_id = '';
        var issue_date = '';
        $scope.isInternet = false;
        $scope.language = uteLocale.language;
        $scope.billCycleDate = '';
        var trackingPayload = {
          payload: {
            events: {
              error: 'true'
            }
          },
          errorType: 'self serve',
          errorCode: '',
          errorMessage: '',
          errorCategory: 'self serve',
          errorField: '',
          errorAPI: '',
          isModalPopup: 'false',
          selectedSections: [],
          mapping: {}
        };

        //net bill generated details storage
        var bbInvoiceLinkAll = [];
        var content_idAll = [];
        var issue_dateAll = [];
        var bbInvoiceLinkAndDate = [];

        if ($stateParams.date) {
          $scope.selectedDate = $stateParams.date;
        }
        if ($stateParams.accountNumber) {
          $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
          $rootScope.userInfo.selectedSubscriberNo = '';
        } else if (!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) {
          $state.go('myAccount.overview');
        } else {
          if (!$stateParams.accountNumber) {
            $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
          }
        }

        if ($stateParams.accountNumber) {
          selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
            return accountDetail.accountNumber === $stateParams.accountNumber;
          });
        }
        var accountNumber = $stateParams.accountNumber;
        $scope.updatedEpostList = [];

        function displayPaymentDate(account) {
          return (
            account &&
            Number(account.balance) > 0 &&
            account.paymentDueDate &&
            account.paymentDueDate !== 'null' &&
            account.MOPType === 'invoice'
          );
        }

        function setAmountFormate(credit) {
          var amount = JSON.stringify(credit);
          return $scope.language === 'en' ? '$' + amount + ' - ' : amount.replace(/\./g, ',') + ' $ - ';
        }

        if (selectedAccountDetail) {
          $scope.payment = {
            accountBalance: selectedAccountDetail.balance,
            date: selectedAccountDetail.paymentDueDate,
            hasWireless: selectedAccountDetail.hasWireless,
            MOPType: selectedAccountDetail.MOPType,
            displayPaymentDate: displayPaymentDate(selectedAccountDetail)
          };
          $scope.billCycleDate = $scope.isSubscriber ? '' : selectedAccountDetail.billCycleDate; //FUSS-1408 fetching bill cycle end date
        }

        if (!selectedAccountDetail.hasWireless && _.isEmpty($scope.payment.MOPType)) {
          $scope.isInternet = true;
          $http({
            method: 'POST',
            url: uteEndpoint('v1/billingArrangementData'),
            data: {
              billingArrangementId: $stateParams.accountNumber
            }
          }).success(function(data) {
            $scope.payment.MOPType = data.methodOfPayment;
          });
        }

        $scope.accountSelected = function(acc) {
          viewInvoice.clearList();
          $state.go('myAccount.viewInvoice', {
            accountNumber: acc,
            date: ''
          });
        };

        $scope.filterWirelessCFA = function(account) {
          return $rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless';
        };

        $scope.filterFraud = function(account) {
          var selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
            return accountDetail.accountNumber === account.accountNumber;
          });

          return selectedAccountDetail.fraud !== true;
        };

        //FUSS-822 Differentiating accounts in dropdown:
        $scope.initAcc = function(accountnumber) {
          _.each($rootScope.userInfo.accounts, function(account) {
            if (account.serviceName == 'Internet/TV') {
              account.serviceNameLabel = 'Internet';
            } else {
              account.serviceNameLabel = 'Mobile';
            }
          });
        };
        $scope.payNow = function() {
          $state.go('myAccount.payNow', {
            accountNumber: $scope.accountNumber
          });
        };
        $scope.changeBill = function(data) {
          $state.go('myAccount.viewInvoice', {
            date: data,
            accountNumber: $scope.accountNumber
          });
        };
        //get bb invoice link for selected/latest date and generate bb invoice
        $scope.getBBLink = function(list, data) {
          console.log('************data :: ' + data);
          console.log('documentId123 :: ' + documentId);
          angular.forEach(list, function(value, key) {
            bbInvoiceLinkAll.push(value.link);
            content_idAll.push(value.content_id);
            issue_dateAll.push(value.issue_date);
            bbInvoiceLinkAndDate.push({ issueDate: value.issue_date, documentId: value.link });

            if (data === value.issue_date) {
              bbInvoiceLink = value.link;
              content_id = value.content_id;
              issue_date = value.issue_date;
            }
          });

          console.log('issue date and the document id : ' + bbInvoiceLinkAndDate);

          $scope.selectedDate = data;
          $scope.billFrame = 'bbSuccess';
          /*Commenting for FIA-472*/
          //$scope.isPageDisable();
          if (data < '2016-06-19') {
            $scope.messageBox = false;
            $scope.findOutMoreLink = false;
          } else if (data > '2016-06-19' && viewInvoice.getShowMessageBoxDiv()) {
            $scope.messageBox = false;
            $scope.findOutMoreLink = true;
          } else {
            $scope.messageBox = false;
            $scope.findOutMoreLink = false;
          }
          $scope.bbAppIframeUrl = $sce.trustAsResourceUrl(
            'viewInvoiceDetail.html?' + bbInvoiceLink + '&' + accountNumber
          );
          documentId = bbInvoiceLink;

          $scope.documentIdSelected = documentId;
          $scope.content_idSelected = content_id;
          $scope.issue_dateSelected = issue_date;

          $scope.allDocumentIdArray = bbInvoiceLinkAll;
          $scope.allContent_idArray = content_idAll;
          $scope.allIssue_dateArray = issue_dateAll;

          $scope.bbInvoiceLinkAndDate = bbInvoiceLinkAndDate;

          console.log('documentId :: ' + documentId);
          console.log('all document id ::' + $scope.allDocumentIdArray);

          try {
            if (dynatraceUptoBBLinkActionId) {
              dtrum.leaveAction(dynatraceUptoBBLinkActionId);
              dynatraceUptoBBLinkActionId = null;
            }
          } catch (error) {}
        };

        //first call to get bb list, populate the invoice date in dropdown
        $scope.getBriteBillInvoiceList = function() {
          var bbApiBase = 'rogers_rest';
          var config = {
            apiBase: bbApiBase,
            cmsBase: '/bbapp/bbcms',
            fromReceiveDate: '2013-10-10',
            appID: 'Fido.ca',
            timeoutUserSummary: '5000',
            timeoutDocuments: '10000'
          };
          BBAPI.setConfig(config);

          console.log(accountNumber);
          $http({
            method: 'POST',
            url: uteEndpoint('olb/retrieveBBToken'),
            data: {
              accountNumber: accountNumber
            }
          }).success(function(tokenNumber) {
            $scope.tokenNumber = tokenNumber.token;
            token = tokenNumber.token;
            console.log('Token Number::' + tokenNumber.token);
            var config = {
              EncryptedToken: $scope.tokenNumber
            };
            BBAPI.setConfig(config);
            BBAPI.getBillsForCurrentUser(
              BBAPI.config.EncryptedToken,
              function(rogersResponse) {
                if (_.isEmpty(rogersResponse.bills)) {
                  $scope.billFrame = 'bbNoRecord';
                  //$scope.dateSelected = 'Older'
                } else {
                  $scope.bbList = rogersResponse.bills;
                  $scope.bbList.sort(function(b, a) {
                    /*if(a['content_id'] > b['content_id']) return 1;
                           if(a['content_id'] < b['content_id']) return -1;
                           return 0;*/
                    return new Date(a['issue_date']).getTime() - new Date(b['issue_date']).getTime(); //sort by issue_date in reverse
                  });
                  processBillingNotification($scope.bbList);
                  viewInvoice.setActivationDate(rogersResponse.activationDate);
                  angular.forEach($scope.bbList, function(value, key) {
                    if (value.issue_date >= rogersResponse.activationDate) {
                      //take the bills which are greater than activation date
                      $scope.dates.push({ issue_date: value.issue_date, amount: setAmountFormate(value.amount) });
                      $scope.tempDates.push(value.issue_date);
                      $scope.bbListUpdated.push(value);
                      console.log($scope.bbListUpdated);
                      /*dates = $scope.dates;*/
                      /*tempDates = $scope.dates;*/
                    }
                  });
                  viewInvoice.setDateList($scope.dates);
                  viewInvoice.setBritebillList($scope.bbListUpdated);
                  if ($scope.tempDates.length > 1) {
                    while (i < $scope.tempDates.length - 1) {
                      var j = i + 1;
                      if ($scope.tempDates[i] > $scope.tempDates[j]) {
                        $scope.tempDates[j] = $scope.tempDates[i];
                        latestDate = $scope.tempDates[j];
                      } else {
                        latestDate = $scope.tempDates[j];
                      }
                      i++;
                    }
                  } else {
                    latestDate = $scope.tempDates[0];
                  }
                  $scope.selectedDate = latestDate;
                  $scope.getBBLink($scope.bbListUpdated, latestDate);
                }
              },
              function(notActivated) {
                $scope.billFrame = 'bbNotRegistered';
              },
              function(jqXHR, textStatus, errorThrown) {
                $scope.billFrame = 'bbError';
                var dtmServerSideError = 'SS|' + dtmServiceConstants.dtmRules.genericBBError.defaultServerError;
                dtmService.setVar(dtmServiceConstants.dtmRules.genericBBError.eVar, dtmServerSideError);
                dtmService.direct(dtmServiceConstants.dtmRules.genericBBError.ruleName);
              }
            );
          });
        };

        $scope.getEpostBills = function() {
          $scope.epostResponse = true;
          $scope.billFrame = 'loader';
          $http({
            method: 'POST',
            url: uteEndpoint('olb/retrieveAllInvoice'),
            data: {
              accountNumber: accountNumber
            }
          })
            .success(function(epostBills) {
              $('.payment-history-table table thead th.sortable').attr('tabindex', 0);
              if (_.isEmpty(epostBills.bills)) {
                $scope.billFrame = 'epostNoRecord';
              } else {
                $scope.billFrame = 'emptyDiv';
                var activationDate = viewInvoice.getActivationDate();
                if (_.isEmpty(activationDate)) {
                  $scope.tableData = epostBills.bills;
                } else {
                  var year = activationDate.substring(0, 4);
                  var month = activationDate.substring(5, 7);
                  var date = activationDate.substring(8, 10);
                  var combinedDate = year + month + date;
                  //alert(year+month+date);
                  $.each(epostBills.bills, function(key, value) {
                    if (value.issue_date < combinedDate) {
                      $scope.updatedEpostList.push(value);
                      console.log(key, value);
                    }
                  });
                  if (_.isEmpty($scope.updatedEpostList)) {
                    $scope.billFrame = 'epostNoRecord';
                  } else {
                    $scope.tableData = $scope.updatedEpostList;
                  }
                }
              }
            })
            .error(function(epostError) {
              $('.payment-history-table table thead th.sortable').attr('tabindex', 0);
              $scope.billFrame = 'epostError';
            });
        };

        //bills are already generated and saved in service & check for subscriber
        if (!$scope.isSubscriber) {
          if (!(viewInvoice.getBritebillList() === null || viewInvoice.getBritebillList() === '')) {
            //for epost calls
            if ($stateParams.date === 'Older') {
              $scope.selectedDate = 'Older';
              $scope.dates = viewInvoice.getDateList();
              $scope.getEpostBills();
            } else {
              if ($stateParams.date === '' || $stateParams.date === null) {
                $scope.getBriteBillInvoiceList();
              } else {
                var dateEntered = $stateParams.date;
                $scope.selectedDate = dateEntered;
                var bbListFromService = viewInvoice.getBritebillList();
                $scope.dates = viewInvoice.getDateList();
                $scope.getBBLink(bbListFromService, dateEntered);
              }
            }
          } // brite bill/epost call to get the bills
          else {
            if ($stateParams.date === 'Older') {
              $scope.selectedDate = 'Older';
              $scope.dates = viewInvoice.getDateList();
              $scope.getEpostBills();
            } else {
              $scope.getBriteBillInvoiceList();
            }
          }
        }

        var tokenNumberForDownloadBill = '';

        $scope.downloadBBPdf = function(data) {
          $http({
            method: 'POST',
            url: uteEndpoint('olb/retrieveBBToken'),
            data: {
              accountNumber: accountNumber
            }
          }).success(function(tokenNumber) {
            if (tokenNumber) {
              tokenNumberForDownloadBill = tokenNumber.token;
              window.location.href =
                'rogers_rest/rogers/' + data + '.pdf?EncryptedToken=' + encodeURIComponent(tokenNumberForDownloadBill);
            }
          });
        };
        /*Commenting for FIA-472 - Start*/
        /*$scope.showWholePage = function() {
          $("#grayOut").hide();
          $("#ute-page").css("zIndex", '1');
          $(".zIndexHigh").css("backgroundColor","transparent");
          $('#slide-bottom-popup').hide();
          $.cookie('userHiddenBillMessage', $rootScope.userInfo.firstName, {
            expires: 1000,
            path: '/'
          });
        }*/
        /*Commenting for FIA-472 - End*/

        $scope.downloadBillOptionModal = function(
          data,
          contentId,
          issue_date,
          allDocumentIdArray,
          allIssue_dateArray,
          bbInvoiceLinkAndDate
        ) {
          // $scope.showWholePage(); /*Commenting for FIA-472*/
          console.log('sata datea nd id' + bbInvoiceLinkAndDate);
          uteModal.open({
            controller: 'downloadBillingOption',
            templateUrl: 'modules/my-account/view-invoice/more-download-option.html',
            data: {
              documentId: data,
              accountNumber: $stateParams.accountNumber,
              content_id: contentId,
              issue_date: issue_date,
              documentIdAll: allDocumentIdArray,
              issueDateAll: allIssue_dateArray,
              bbInvoiceLinkAndDate: bbInvoiceLinkAndDate
            },
            ok: function() {
              console.log('OK');
            },
            cancel: function() {
              console.log('CANCEL');
            }
          });
        };

        self.init = function() {
          try {
            dynatracePageLoadActionId = dtrum.enterAction('page load – view bill', 'change');
            dynatraceUptoBBLinkActionId = dtrum.enterAction('View Bill Widget – view bill', 'change');
          } catch (error) {}

          if ($rootScope.userInfo && ($rootScope.userInfo.accounts || []).length > 0) {
            if ($stateParams.accountNumber) {
              $scope.selectedAccountNumber = $stateParams.accountNumber;
            } else {
              $scope.selectedAccountNumber = $rootScope.userInfo.accounts[0].accountNumber;
            }

            // self.loadPaymentDetails();
          }
        };

        self.init();
        $scope.closeMessageBox = function() {
          $scope.messageBox = false;
          $scope.findOutMoreLink = true;
          viewInvoice.setShowMessageBoxDiv(true);
        };
        $scope.showMoreBillingEnhancement = function() {
          $scope.closeMessageBox();
          uteModal.open({
            controller: 'billingEnhancementModalCtrl',
            templateUrl: 'modules/my-account/view-invoice/billing-enhancement-pop-up.html',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            ok: function() {
              console.log('OK');
            },
            cancel: function() {
              console.log('CANCEL');
            }
          });
        };
        $scope.showMoreBillingEnhancementMobile = function() {
          $scope.closeMessageBox();
          uteModal.open({
            controller: 'billingEnhancementMobileModalCtrl',
            templateUrl: 'modules/my-account/view-invoice/billing-enhancement-mobile-pop-up.html',
            backdrop: 'static',
            keyboard: false,
            size: 'sm',
            ok: function() {
              console.log('OK');
            },
            cancel: function() {
              console.log('CANCEL');
            }
          });
        };
        $scope.columnSize = 'col-md-2';
        if (uteLocale.language === 'fr') {
          $scope.columnSize = 'col-md-4';
        }

        setTimeout(function() {
          $('.payment-history-table table thead th.sortable').keypress(function(e) {
            if (e.which === 13) {
              this.click();
            }
          });
        }, 0);

        $scope.$on('view-invoice-header', function(event, args) {
          if ($scope.billFrame === 'bbSuccess') {
            document.getElementById('bbAppIFrame').contentWindow.location.reload();
          }
        });

        function processBillingNotification(bills) {
          var billCycleEndMonth, accountsDetails, email, issueDate, billCycleEndDate, today;

          accountsDetails = selectedAccountDetail;
          today = moment().startOf('day');

          if (accountsDetails.billCycleDate) {
            //format we get back from server for billCycleDate: "April 12,2018"
            billCycleEndDate = deriveBillCycleEndDate(moment(accountsDetails.billCycleDate), today);
            billCycleEndMonth = billCycleEndDate.format('MMMM');
          }

          email = _.get(accountsDetails, 'contactEmail', '');

          if (bills && angular.isArray(bills) && bills.length > 0 && bills[0].issue_date) {
            //format we get back from server for issue_date: "2018-04-09"
            issueDate = moment(bills[0].issue_date, 'YYYY-MM-DD');
          }

          if (
            issueDate &&
            issueDate.isValid() &&
            billCycleEndDate &&
            billCycleEndDate.isValid() &&
            billCycleEndDate.diff(issueDate, 'day') > 0 &&
            today.diff(billCycleEndDate, 'day') > 0
          ) {
            generateNotification(accountsDetails.billingType, billCycleEndMonth, email);
          }
        }

        function deriveBillCycleEndDate(billCycleEndDate, today) {
          var todayLastMonth = moment(today).subtract(1, 'month');
          var targetBillCycleEndDate;
          var counter;

          if (billCycleEndDate.isAfter(today)) {
            var prevBillCycleEndDate;
            counter = 0;
            do {
              counter++;
              prevBillCycleEndDate = moment(billCycleEndDate).subtract(counter, 'month');
            } while (!(prevBillCycleEndDate.isBetween(todayLastMonth, today) || prevBillCycleEndDate.isSame(today)));
            targetBillCycleEndDate = prevBillCycleEndDate;
          } else if (billCycleEndDate.isBetween(todayLastMonth, today) || billCycleEndDate.isSame(today)) {
            targetBillCycleEndDate = billCycleEndDate;
          } else {
            // actual condition: billCycleEndDate.isBefore(todayLastMonth) || || billCycleEndDate.isSame(todayLastMonth)
            var nextBillCycleEndDate;
            counter = 0;
            do {
              counter++;
              nextBillCycleEndDate = moment(billCycleEndDate).add(counter, 'month');
            } while (!(nextBillCycleEndDate.isBetween(todayLastMonth, today) || nextBillCycleEndDate.isSame(today)));
            targetBillCycleEndDate = nextBillCycleEndDate;
          }
          return targetBillCycleEndDate;
        }

        function generateNotification(billingType, monthName, email) {
          if (billingType === 'Online') {
            if (email) {
              $scope.billingNotification = $translate.instant('global.message.billNotificationForOnlineBillWithEmail', {
                monthName: monthName,
                email: email
              });
            } else {
              $scope.billingNotification = $translate.instant('global.message.billNotificationForOnlineBillNoEmail', {
                monthName: monthName
              });
            }
          } else {
            $scope.billingNotification = $translate.instant('global.message.billNotificationForPaperBill', {
              monthName: monthName
            });
          }

          // Set error message as a plain text with escaping html characters.
          trackingPayload.errorMessage = $scope.billingNotification
            ? String($scope.billingNotification).replace(/<[^>]+>/gm, '')
            : '';

          //Start tracking analytics call.
          if (dataLayerService && dataLayerService.trackError && typeof dataLayerService.trackError === 'function') {
            dataLayerService.trackError(
              trackingPayload.data,
              trackingPayload.errorType,
              trackingPayload.errorCode,
              trackingPayload.errorMessage,
              trackingPayload.errorCategory,
              trackingPayload.errorField,
              trackingPayload.errorAPI,
              trackingPayload.isModalPopup,
              trackingPayload.selectedSections,
              trackingPayload.mapping
            );
          }
        }
        $scope.$on('$viewContentLoaded', function(event) {
          try {
            if (dynatracePageLoadActionId) {
              dtrum.leaveAction(dynatracePageLoadActionId);
              dynatracePageLoadActionId = null;
            }
          } catch (error) {}
        });
      }
    ])
    .controller('epostTableCtrl', [
      '$scope',
      function($scope) {
        $scope.downloadPdf = function(data) {
          window.location.href = data;
        };
      }
    ])
    .filter('epostInvoiceDateFormat', [
      '$filter',
      function epostInvoiceDateFormat($filter) {
        return function(text) {
          var day = text.substring(6, 8);
          var month = text.substring(4, 6) - 1;
          var year = text.substring(0, 4);
          var tempdate = new Date(year, month, day);
          return $filter('date')(tempdate, 'MMMM yyyy');
        };
      }
    ])
    .filter('invoiceDateFormat', [
      '$filter',
      function invoiceDateFormat($filter) {
        return function(text, lang) {
          if (lang == 'fr') {
            var date = $filter('date')(text, 'dd MMM yyyy');
            console.log(date);
            var month = date.indexOf('.');
            if (month >= 0) {
              return date;
            } else {
              return $filter('date')(text, 'dd MMM. yyyy');
            }
          } else {
            return $filter('date')(text, 'MMM. dd, yyyy');
          }
        };
      }
    ])
    .filter('paymentDateFormat', [
      '$filter',
      function paymentDateFormat($filter) {
        return function(text, lang) {
          if (lang == 'fr') {
            var date = $filter('date')(text, 'dd MMMM yyyy');
          } else {
            var date = $filter('date')(text, 'MMMM dd, yyyy');
          }
          var paymentDate = date.replace(/\b0/, '');
          return paymentDate;
        };
      }
    ]);
})();
